import { render, staticRenderFns } from "./SaleForm.vue?vue&type=template&id=d134b16a&"
import script from "./SaleForm.vue?vue&type=script&lang=js&"
export * from "./SaleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports